/* eslint-disable max-len */
import React from 'react';

const THCVIcon = (props) => (
  <svg width='62' height='36' viewBox='0 0 62 36' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M35.9016 10.8611C37.1076 10.8611 37.9896 9.99707 37.9896 8.79107C37.9896 7.58507 37.1076 6.72107 35.9016 6.72107C34.6896 6.72107 33.8076 7.58507 33.8076 8.79107C33.8076 9.99707 34.6896 10.8611 35.9016 10.8611ZM35.9016 10.1051C35.1576 10.1051 34.6836 9.53507 34.6836 8.79107C34.6836 8.04107 35.1576 7.47707 35.9016 7.47707C36.6396 7.47707 37.1136 8.04107 37.1136 8.79107C37.1136 9.53507 36.6396 10.1051 35.9016 10.1051Z'
      fill='#4F5D68'
    />
    <path
      d='M42.1875 10.7891V6.78707H41.3295V8.35907H39.4395V6.78707H38.5875V10.7891H39.4395V9.10307H41.3295V10.7891H42.1875Z'
      fill='#4F5D68'
    />
    <path
      d='M20.9016 35.8611C22.1076 35.8611 22.9896 34.9971 22.9896 33.7911C22.9896 32.5851 22.1076 31.7211 20.9016 31.7211C19.6896 31.7211 18.8076 32.5851 18.8076 33.7911C18.8076 34.9971 19.6896 35.8611 20.9016 35.8611ZM20.9016 35.1051C20.1576 35.1051 19.6836 34.5351 19.6836 33.7911C19.6836 33.0411 20.1576 32.4771 20.9016 32.4771C21.6396 32.4771 22.1136 33.0411 22.1136 33.7911C22.1136 34.5351 21.6396 35.1051 20.9016 35.1051Z'
      fill='#4F5D68'
    />
    <path
      d='M30.6 11.7891V7.78706H29.742V9.35906H27.852V7.78706H27V11.7891H27.852V10.1031H29.742V11.7891H30.6Z'
      fill='#4F5D68'
    />
    <path d='M3.6 28.789V24.787H2.742V26.359H0.852V24.787H0V28.789H0.852V27.103H2.742V28.789H3.6Z' fill='#4F5D68' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.8773 5.30457V0.179688H14.8773V5.30751L21.6569 9.00552V15.6914L26.0401 12.5923L27.1947 14.2253L22.5364 17.519L27.2348 20.1145L33.075 17.0212V11.9017H35.075V17.0495L41.9959 21.0963V28.5505L47.71 31.7595L54.5603 27.9918L61.7539 32.0317L60.7746 33.7755L54.5502 30.2799L47.6999 34.0477L40.9884 30.2785L34.0726 34.0435L27.4121 30.3801L24.2966 33.5991L22.8595 32.2081L26.2247 28.7311V21.8414L20.6376 18.7549L14.552 21.8505L14.8576 28.6738L18.7187 32.1615L17.3781 33.6457L14.3937 30.9498L13.2842 34.7862L11.363 34.2306L12.4387 30.5106L8.60279 31.4338L8.13482 29.4893L12.8414 28.3566L12.5972 22.9048L6.74732 26.132L5.78125 24.3808L11.5217 21.214L6.027 17.9096V9.00258L12.8773 5.30457ZM13.8748 7.03888L8.027 10.1957V16.7785L13.5647 20.1088L19.6569 17.0099V10.1928L13.8748 7.03888ZM28.2247 21.8533V28.5446L34.0775 31.7637L39.9959 28.5416V22.2437L34.051 18.7675L28.2247 21.8533Z'
      fill='#64737F'
    />
  </svg>
);

export default THCVIcon;
